import _define_property from "@swc/helpers/src/_define_property.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAnalytics } from "@cinch-nx/shared-analytics";
import cx from "classnames";
import { Filters } from "./filters";
import { HeroHeading } from "./hero-heading/hero-heading";
import { HeroSubheading } from "./hero-subheading/hero-subheading";
import { HeroLink } from "./hero-link/hero-link";
import { HeroImage } from "./hero-image/hero-image";
import styles from "./hero.module.css";
import { TrustpilotWidget, TrustpilotWidgetTemplates, Wrapper } from "@cinch-nx/shared-ui";
import { useViewport } from "@cinch-labs/shared-util";
import { TrustpilotOverviewV2 } from "@cinch-nx/landing-ui-shared";
var HomeHeroV2 = function(props) {
    var makes = props.makes, totalStock = props.totalStock, starRating = props.starRating, starRatingLabel = props.starRatingLabel, heading = props.heading, subheading = props.subheading, _heroLink = _sliced_to_array(props.heroLink, 1), heroLink = _heroLink[0], image = props.image, isMobileImageShown = props.isMobileImageShown, numberOfReviews = props.numberOfReviews;
    var vw = useViewport({
        updateOnResize: true,
        updateOnOrientationChange: true
    }).vw;
    var trackEvent = useAnalytics().trackEvent;
    var isMobile = vw < 1024;
    return /*#__PURE__*/ _jsxs("section", {
        className: styles["container"],
        "aria-describedby": "hero-heading",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: cx(styles["background"], styles["backgroundGradient"]),
                children: /*#__PURE__*/ _jsxs("div", {
                    className: styles["heroInner"],
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: cx(styles["textAndImageContainer"], _define_property({}, styles["isMobileImageShown"], isMobileImageShown)),
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: styles["textContainer"],
                                    children: [
                                        /*#__PURE__*/ _jsx(HeroHeading, {
                                            heading: heading
                                        }),
                                        /*#__PURE__*/ _jsx(HeroSubheading, {
                                            subheading: subheading
                                        }),
                                        /*#__PURE__*/ _jsx(HeroLink, _object_spread_props(_object_spread({}, heroLink), {
                                            trackEvent: trackEvent
                                        }))
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: styles["imageGridContainer"],
                                    children: /*#__PURE__*/ _jsx(HeroImage, {
                                        image: image,
                                        isMobileImageShown: isMobileImageShown
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Filters, {
                            makes: makes,
                            totalStock: totalStock,
                            starRating: starRating,
                            starRatingLabel: starRatingLabel,
                            numberOfReviews: numberOfReviews
                        })
                    ]
                })
            }),
            isMobile && /*#__PURE__*/ _jsx("div", {
                className: styles["trustpilotMobile"],
                children: /*#__PURE__*/ _jsx(TrustpilotOverviewV2, {
                    starRating: starRating,
                    starRatingLabel: starRatingLabel,
                    numberOfReviews: numberOfReviews,
                    className: styles["trustpilotOverview"]
                })
            }),
            !isMobile && /*#__PURE__*/ _jsx(Wrapper, {
                backgroundColor: "#f8f6ff",
                className: {
                    inner: styles.trustpilotWrapper
                },
                children: /*#__PURE__*/ _jsx(TrustpilotWidget, {
                    height: "24px",
                    widget: isMobile ? TrustpilotWidgetTemplates.microStar : TrustpilotWidgetTemplates.microCombo
                })
            })
        ]
    });
};
export default HomeHeroV2;
